export class TimeoutError extends Error {
  constructor(message) {
    super();
    this.message = message || i18n.$t('Timed out');
  }
}
